/* globals google */
'use strict';

const { queryFirst, queryAll, addClass, removeClass } = require('../domUtil');
const { getJSON, geolocate } = require('../util');
const { clearForm } = require('../clientSideValidation').functions;
const { getLatLong } = require('../googleMaps');

const detectLocationLinkEl = queryFirst('.detect-location');

const $body = $('body');

let searchData = {
    latitude: '',
    longitude: '',
    radius: '',
    storeType: 'ALL_STORES'
};

/**
 * Uses google maps api to render a map
 */
function maps() {
    const infowindow = new google.maps.InfoWindow();

    // Init U.S. Map in the center of the viewport
    const latlng = new google.maps.LatLng(37.09024, -95.712891);
    const mapOptions = {
        scrollwheel: false,
        zoom: 4,
        center: latlng,
        zoomControl: true,
        mapTypeControl: false,
        fullscreenControl: false,
        streetViewControl: false
    };

    const map = new google.maps.Map($('.map-canvas')[0], mapOptions);
    const mapCanvas = $('.map-canvas');
    const mapImageObserver = new MutationObserver(function (mutationList) {
        for (let mutation of mutationList) {
            if(mutation.type == 'attributes' && mutation.attributeName == 'data-locations') {
                const { target } = mutation;
                setTimeout(() => {
                    const images = queryAll('button img', target);
                    if(images) {
                        images.forEach(function(image) {
                            image.setAttribute('alt', 'Google Maps Image');
                        });
                    }
                }, 2400);
            }
        }
    });
    const mapObserverConfig = { attributeFilter: [ "data-locations" ], attributeOldValue: true, subtree: true };
    mapImageObserver.observe(mapCanvas[0], mapObserverConfig);
    
    let mapdiv = mapCanvas.attr('data-locations');
    const jwStoreMarkerIcon = mapCanvas.attr('data-jw-store-marker');
    const bounds = new google.maps.LatLngBounds();

    // Fit the all the store marks in the center of a minimum bounds when any store has been found.
    if (mapdiv && mapdiv !== 'null' && mapdiv.length !== 0) {
        mapdiv = JSON.parse(mapdiv);

        Object.keys(mapdiv).forEach(function (key) {
            const item = mapdiv[key];
            const storeLocation = new google.maps.LatLng(
                item.latitude,
                item.longitude
            );
            const marker = new google.maps.Marker({
                position: storeLocation,
                map: map,
                title: item.name,
                icon: jwStoreMarkerIcon
            });

            marker.addListener('click', function () {
                infowindow.setOptions({
                    content: item.infoWindowHtml
                });
                infowindow.open(map, marker);
            });

            // Create a minimum bound based on a set of storeLocations
            bounds.extend(marker.position);
        });

        if (mapdiv.length) {
            map.fitBounds(bounds);
        }
    }
}

/**
 * Renders the results of the search and updates the map
 * @param {Object} data - Response from the server
 */
function updateStoresResults(data) {
    const $resultsDiv = $('.results');
    const $mapDiv = $('.map-canvas');
    const hasResults = data.stores.length > 0;

    if (!hasResults) {
        $('.store-locator-no-results').show();
    } else {
        $('.store-locator-no-results').hide();
    }

    $resultsDiv.empty();
    $mapDiv.attr('data-locations', data.locations);

    if ($mapDiv.data('has-google-api')) {
        maps();
    } else {
        $('.store-locator-no-apiKey').show();
    }

    if (data.storesResultsHtml) {
        $resultsDiv.append(data.storesResultsHtml);
        $resultsDiv.trigger('getStores:update');
    }
}

/**
 * Renders the results of the search and updates the map
 * @param {Object} data - Response from the server
 */
function handleStoreResults(data) {
    $.spinner().stop();
    updateStoresResults(data);
}

/**
 * Handles error response of search
 */
function errorCallBack() {
    $.spinner().stop();
}

/**
 * Function that gets stores list as per location data passeds
 * @param {Object} locationData - Latitude, longitude, radius for the particular location
 */
function getStores(locationData) {
    const { latitude, longitude, radius, actionUrl } = locationData;

    const searchDataToSend = {
        radius,
        latitude,
        longitude
    };
    // Updates searchData state
    searchData = Object.assign(searchData, {
        radius,
        latitude,
        longitude
    });

    $.spinner().start();
    getJSON(actionUrl, 'GET', searchDataToSend, handleStoreResults, errorCallBack);
}

/**
 * Function that gets stores list on storeType change
 * @param {string} storeType - Can be 'ALL_STORES' / 'JW_STORES' / 'PARTNER_STORES'
 */
function filterByStoreType(storeType) {
    const $form = $('.store-locator');
    const actionUrl = $form.attr('action');

    const { radius, latitude, longitude } = searchData;

    const searchDataToSend = {
        storeType,
        radius,
        latitude,
        longitude
    };

    // Updates searchData state
    searchData = Object.assign(searchData, {
        storeType
    });

    $body.trigger('storelocator:filter', {
        storeType
    });

    $.spinner().start();
    getJSON(actionUrl, 'GET', searchDataToSend, handleStoreResults, errorCallBack);
}

/**
 * Search for stores with entered address
 */
function search() {
    const $form = $('.store-locator');
    const address = $form.find('[name="postalCode"]').val();
    const radius = $form.find('.radius').val();

    $body.trigger('storelocator:search', {
        radius
    });

    getLatLong(getStores, {
        address,
        radius,
        actionUrl: $form.attr('action')
    });
}

/**
 * Function to set preferred store
 */
function setPreferredStore() {
    $('.store-locator-container').on('click', '.set-preferred-store a', (event) => {
        const setPreferredStoreLink = event.target;
        const { actionUrl, storeId } = setPreferredStoreLink.dataset;

        $.spinner().start();
        getJSON(actionUrl, 'POST', {
            storeID: storeId
        }, () => {
            removeClass(queryAll('.set-preferred-store'), 'hide');
            addClass(setPreferredStoreLink.closest('.set-preferred-store'), 'hide');
            removeClass(queryAll('.preferred-store-label'), 'show');
            const storeDetails = setPreferredStoreLink.closest('.store-details');
            addClass(queryFirst('.preferred-store-label', storeDetails), 'show');
            $.spinner().stop();
        }, () => {
            $.spinner().stop();
        });
    });
}

/**
 * Callback for successful geolocation
 * @param {Object} data - Response object
 */
function onGeolocateSuccess(data) {
    getStores(data);
    detectLocationLinkEl.style.display = 'block';
}

/**
 * Callback for failure geolocation
 */
function onGeolocateFailure() {
    detectLocationLinkEl.style.display = 'none';
}

module.exports = {
    init: function () {
        if ($('.map-canvas').data('has-google-api')) {
            maps();
        } else {
            $('.store-locator-no-apiKey').show();
        }
        const $form = $('.store-locator');
        const $radius = $form.find('.radius').val()
          ? $form.find('.radius').val()
          : $form.find('.radius option')[1].value;

        geolocate(
            onGeolocateSuccess,
            {
                radius: $radius,
                actionUrl: $form.attr('action')
            },
            () => {
                onGeolocateFailure();
                const address = $form.data('default-location');

                getLatLong(getStores, {
                    address,
                    radius: 5000,
                    actionUrl: $form.attr('action')
                });
            }
        );
    },

    detectLocation: function () {
        // clicking on detect location.
        $('.detect-location').on('click', function () {
            const $form = $('.store-locator');
            clearForm($form);

            geolocate(
                onGeolocateSuccess,
                {
                    radius: $form.find('.radius').val(),
                    actionUrl: $form.attr('action')
                },
                onGeolocateFailure
            );
        });
    },

    search: function () {
        const storeLocatorContainerEl = queryFirst('.store-locator-container');

        const storeLocatorFormEl = queryFirst('form.store-locator', storeLocatorContainerEl);
        const storeLocatorSearchBtn = queryFirst('.btn-storelocator-search', storeLocatorContainerEl);
        const storeLocatorFilterRadioBtns = queryAll('input[name=store-filter-radio]', storeLocatorContainerEl);

        const callback = event => {
            event.preventDefault();
            search();
        };

        if (storeLocatorFormEl) {
            storeLocatorFormEl.addEventListener('submit', callback);
        }
        if (storeLocatorSearchBtn) {
            storeLocatorSearchBtn.addEventListener('click', callback);
        }
        if (storeLocatorFilterRadioBtns) {
            storeLocatorFilterRadioBtns.forEach(storeLocatorFilterRadioBtn => {
                storeLocatorFilterRadioBtn.addEventListener('change', event => {
                    event.preventDefault();

                    filterByStoreType(event.target.value);
                });
            });
        }
    },

    setPreferredStore: setPreferredStore
};
